import { Injectable } from '@angular/core';
import { ValidatorService } from 'src/app/core/validator/validator.service';
import { WorkshopDefect } from '../models/workshop-defect.model';

@Injectable({
  providedIn: 'root'
})
export class WorkshopDefectValidatorService extends ValidatorService {
  isValid(data: WorkshopDefect) {
    this.errors = [];

    if(!this.isDropdownSupplied(data.vehicleId)) {
      this.errors.push('vehicleId');
    }

    if(!this.isSupplied(data.description)) {
      this.errors.push('description');
    }

    if(!this.isDropdownSupplied(data.severityId)) {
      this.errors.push('severityId');
    }

    return this.errors.length === 0;
  }
}
